import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';

import { BottomSheet } from '@finn-no/troika-react-bottom-sheet';
import '@finn-no/troika-react-bottom-sheet/dist/style.css';

const {
    publicRuntimeConfig: { adInUrl, adminUrl },
} = getConfig();

export const PreviewBottomSheet = ({ adId, isPrivate, isAdmin }) => {
    const editAdUrl = isPrivate ? `${adInUrl}/${adId}` : isAdmin ? `${adminUrl}?finnkode=${adId}` : undefined;

    return (
        <BottomSheet open={true} blocking={false} scrollLocking={false}>
            <div className="p-16 sm:p-32 grid md:grid-cols-2 gap-16">
                <div>
                    <p className="font-bold text-22">Sjekk annonsen før den legges ut</p>
                    <ul className="list list-checked">
                        <li>Sjekk at teksten er som den skal - er det noen skrivefeil?</li>
                        <li>Har du sjekket at bildene er gode?</li>
                    </ul>
                </div>
                <div>
                    <a className="button button--primary" href={editAdUrl}>
                        Endre annonsen
                    </a>
                </div>
            </div>
        </BottomSheet>
    );
};

PreviewBottomSheet.propTypes = {
    adId: PropTypes.number.isRequired,
    isPrivate: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
};
